// © 2015-2021 WDNA - All Rights Reserved

import { RedirectProps } from 'react-router';

import WasteDashboard from './waste/loaders/Dashboard';
import FBoardDashboard from './fboard/loaders/Dashboard';
import MetDashboard from './meteo/loaders/Dashboard';
import GTrackingDashboard from './gtracking/loaders/Dashboard';
import GPositionDashboard from './gposition/loaders/Dashboard';

export const redirects: RedirectProps[] = [
  {
    from: '/dashboard',
    to: '/dashboard/fboard',
  },
];

export const routes: any[] = [
  {
    component: WasteDashboard,
    path: '/dashboard/waste',
    code: 'dashboard_waste',
    name: '5GWaste Dashboard',
  },
  {
    component: FBoardDashboard,
    path: '/dashboard/fboard',
    code: 'dashboard_fboard',
    name: 'Custom Dashboard',
  },
  {
    component: MetDashboard,
    path: '/dashboard/meteo',
    code: 'dashboard_meteo',
    name: 'Meteo Dashboard'
  },
  {
    component: GTrackingDashboard,
    path: '/dashboard/gtracking',
    code: 'dashboard_gtracking',
    name: 'GeoTracking Dashboard'
  },
  {
    component: GPositionDashboard,
    path: '/dashboard/gposition',
    code: 'dashboard_gposition',
    name: 'GeoPosition Dashboard'
  },
];
